import { t } from '@lingui/core/macro';
import { Alert } from '@pocketlaw/tetris';
export function ErrorMessage(props) {
    const { error } = props;
    const messages = {
        ALREADY_INVITED: t({
            message: 'An invite has already been sent to this email address for this document.',
            comment: 'Error message when failing to invite external user to document',
        }),
        ALREADY_HAS_ACCESS: t({
            message: 'The user already has access to this document as a member of your company.',
            comment: 'Error message when failing to invite external user to document',
        }),
        IS_COMPANY_MEMBER: t({
            message: 'This email address belongs to a company user and cannot be added as an external user. Please grant access to this user through the usual access management.',
            comment: 'Error message when failing to invite external user to document',
        }),
        DEFAULT: t({
            message: 'There was a problem sending the invite',
            comment: 'Default error message when failing to invite external user to document',
        }),
    };
    if (!(error === null || error === void 0 ? void 0 : error.message)) {
        return null;
    }
    const code = error.message;
    const message = messages[code] || messages.DEFAULT;
    return <Alert appearance="danger" message={message}/>;
}
